import {
  AssessmentDocument,
  useCreateAssessmentMutation,
  CreateAssessmentMutationVariables,
} from "@/features/assessments/graphql/generated";

export const useCreateAssessment = () => {
  const [createAssessment, { loading }] = useCreateAssessmentMutation();

  const handleCreateAssessment = async (
    variables: CreateAssessmentMutationVariables
  ) => {
    const result = await createAssessment({
      variables,
      // The create mutation returns only { id }; the evaluation view then reads the
      // full assessment (scorecard, person, rows). Refetch and await that here so
      // the cache is warm before we navigate — otherwise the view renders a
      // brand-new assessment "cold" with incomplete data and crashes (ErrorBoundary
      // -> dashboard). On direct navigation the assessment is already cached, which
      // is why this only bit right after creation.
      refetchQueries: (mutationResult) => {
        const newId = mutationResult.data?.createAssessment?.id;
        return newId
          ? [{ query: AssessmentDocument, variables: { id: newId } }]
          : [];
      },
      awaitRefetchQueries: true,
    });

    return result.data?.createAssessment;
  };

  return {
    loading,
    handleCreateAssessment,
  };
};
